var map = {
	"./de/apple_store.svg": 831,
	"./de/google_store.png": 868,
	"./en/apple_store.svg": 832,
	"./en/google_store.png": 869,
	"./en/logo-smc-white.svg": 833,
	"./en/stingray_business_logo_horizontal.svg": 834,
	"./en/stingray_classica_horizontal.svg": 835,
	"./en/stingray_karaoke_logo.png": 870,
	"./en/stingray_logo_horizontal.svg": 836,
	"./en/stingray_music_hor_white.svg": 837,
	"./en/stingray_qello_horizontal.svg": 838,
	"./en/tsm_karaoke_horizontal.png": 871,
	"./es/apple_store.svg": 839,
	"./es/google_store.png": 872,
	"./fi/apple_store.svg": 840,
	"./fi/google_store.png": 873,
	"./fr/apple_store.svg": 841,
	"./fr/google_store.png": 874,
	"./fr/stingray_business_logo_horizontal.svg": 842,
	"./fr/stingray_music_hor_white.svg": 843,
	"./hu/apple_store.svg": 844,
	"./hu/google_store.png": 875,
	"./logo_classica.svg": 422,
	"./logo_music.svg": 423,
	"./logo_qello.svg": 424,
	"./logo_smc.svg": 425,
	"./logo_stingray.svg": 426,
	"./logo_stingraykaraoke.svg": 427,
	"./nb/apple_store.svg": 845,
	"./nb/google_store.png": 876,
	"./nl/apple_store.svg": 846,
	"./nl/google_store.png": 877,
	"./pt/apple_store.svg": 847,
	"./pt/google_store.png": 878,
	"./stingray.svg": 428,
	"./stingray_logo_horizontal_white.svg": 99
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2053;



//////////////////
// WEBPACK FOOTER
// ./res/images/logo ^\.\/.*$
// module id = 2053
// module chunks = 0